import { Controller } from 'stimulus';
import { debounce } from 'lodash';

export default class extends Controller {
  static targets = ['description', 'descriptionTruncated', 'descriptionToggle']
  static values = { expanded: Boolean, }

  connect() {
    this.useTruncatedDescription = this.element.getAttribute('data-use-truncated-description') === 'true';
    this.hideDesktopToggle = this.element.getAttribute('data-hide-desktop-toggle') === 'true';

    if (!this.useTruncatedDescription) return;

    this.expandedValue = false;
    this.updateButton();
    this.handleResize(); 

    this.debouncedResize = debounce(this.handleResize.bind(this), 100);
    window.addEventListener('resize', this.debouncedResize);
  }

  disconnect() {
    if (!this.useTruncatedDescription) return;
    window.removeEventListener('resize', this.debouncedResize);
  }

  toggleDescription() {
    this.expandedValue = !this.expandedValue;
    this.descriptionToggleTarget.classList.toggle('is-expanded');


    if (this.expandedValue) {
      this.expandSection();
    } else {
      this.collapseSection();
    }

    this.updateButton();
  }

  expandSection() {
    const element = this.descriptionTarget;
    element.classList.remove('is-hidden');
    element.style.height = `${element.scrollHeight}px`;

    element.addEventListener('transitionend', () => {
      if (this.expandedValue) {
        element.style.height = null;
      }
    }, { once: true });

    this.descriptionTruncatedTarget.classList.add('is-hidden');
  }

  collapseSection() {
    const element = this.descriptionTarget;
    element.style.height = `${element.scrollHeight}px`;
    requestAnimationFrame(() => {
      element.style.height = '0px';
    });

    element.classList.add('is-hidden');
    this.descriptionTruncatedTarget.classList.remove('is-hidden');
  }

  updateButton() {
    if (!this.hasDescriptionToggleTarget) return;
    const isExpanded = this.expandedValue;
    this.descriptionToggleTarget.setAttribute('aria-expanded', isExpanded.toString());
  }

    handleResize() {
    if (!this.hasDescriptionToggleTarget) return;
    if (window.innerWidth > 1024 && !!this.hideDesktopToggle) {
      this.expandedValue = true;
      this.expandSection();
      this.descriptionToggleTarget.classList.add('is-hidden');
    } else if (window.innerWidth > 1024 && !this.hideDesktopToggle || window.innerWidth < 1024) {
      this.expandedValue = false;
      this.collapseSection();
      this.descriptionToggleTarget.classList.remove('is-hidden');
    }
    this.updateButton();
  }

}
